import React from "react";
import LegalPage from "@/components/LegalPage";
import usePageMeta from "@/lib/usePageMeta";

export default function Cookiepolitik() {
  usePageMeta({
    title: "Cookiepolitik",
    description:
      "Sådan bruger Hagelund ApS cookies og lignende teknologier på hjemmesiden.",
  });

  return (
    <LegalPage
      testId="cookies-page"
      eyebrow="Juridisk"
      title="Cookiepolitik"
      updated="August 2026"
      sections={[
        {
          number: "01",
          heading: "Hvad er cookies?",
          body:
            "Cookies er små tekstfiler, som lagres i din browser, når du besøger en hjemmeside. De bruges blandt andet til at få sider til at fungere, huske dine valg og indsamle statistik om, hvordan siden anvendes.",
        },
        {
          number: "02",
          heading: "Hvilke cookies og teknologier bruger vi?",
          body:
            "På hagelundtoemrer.dk anvender vi to kategorier af cookies og lignende lagringsteknologier:",
          list: [
            "Nødvendige (altid aktive): Lokal lagring (localStorage), der gør det muligt at logge ind i vores administrationsmodul samt huske dit valg af cookiesamtykke. Anvendes også af standard hosting-cookies, som er nødvendige for at hjemmesiden fungerer sikkert og korrekt.",
            "Statistik (kræver dit samtykke): Google Analytics 4 (måler-ID G-4JRX2PXTCD) — anvendes til anonymiseret trafikstatistik, så vi kan forbedre indhold og brugeroplevelse. Indlæses gennem Google Tag Manager (container GTM-NBZQ2HCH).",
          ],
        },
        {
          number: "03",
          heading: "Samtykke og Google Consent Mode v2",
          body:
            "Første gang du besøger hjemmesiden, viser vi et cookiebanner, hvor du kan vælge “Acceptér alle” eller “Kun nødvendige”. Indtil du giver dit samtykke, er analytics_storage, ad_storage, ad_user_data og ad_personalization sat til denied via Google Consent Mode v2 — det betyder at Google Analytics ikke indsamler personhenførbare data eller cookies før du accepterer. Vælger du “Kun nødvendige”, forbliver de i denied-tilstand. Du kan altid ændre dit samtykke via linket “Ændr cookiesamtykke” nederst på siden.",
        },
        {
          number: "04",
          heading: "Videregivelse og databehandlere",
          body:
            "Når du accepterer statistik-cookies, deles anonymiseret brugsstatistik med Google (Google Analytics 4 og Google Tag Manager). Google er databehandler og kan overføre data til lande uden for EU/EØS på grundlag af EU-Kommissionens standardkontraktbestemmelser og EU-U.S. Data Privacy Framework.",
        },
        {
          number: "05",
          heading: "Sådan slår du cookies fra eller trækker samtykke tilbage",
          body:
            "Du kan altid ændre dit samtykke via linket “Ændr cookiesamtykke” nederst på hjemmesiden, eller slette gemte cookies i din browsers indstillinger. Fremgangsmåden afhænger af din browser — søg efter “Slet cookies” i browserens hjælp. Vær opmærksom på, at hjemmesiden kan miste funktionalitet, hvis du slår teknisk nødvendige cookies fra.",
        },
        {
          number: "06",
          heading: "Behandling af personoplysninger",
          body:
            "Læs vores fulde politik for behandling af personoplysninger her:",
          list: ["Privatlivspolitik — hagelundtoemrer.dk/privatlivspolitik"],
        },
        {
          number: "07",
          heading: "Kontakt",
          body:
            "Har du spørgsmål til vores brug af cookies, er du velkommen til at kontakte os:\n\nHagelund ApS\nAugustvej 7, 2860 Søborg\nCVR-nr. 39651017\nTelefon: 22 56 14 15\nE-mail: ch@hagelund-aps.dk",
        },
      ]}
    />
  );
}
